(function ( $ ) {

	$.fn.videolightbox = function () {
		var $elem = $( this ),
			$trigger = $elem.find( '.video-lightbox-trigger' );

		var init = function () {
				if ( $trigger.length > 0 ) {
					bindEvents();
				}

			},
			bindEvents = function () {
				$elem.on( 'click', '.video-lightbox-trigger', function ( e ) {
					e.preventDefault();

					var youtubeId = $( this ).data( 'youtube-id' );

					if ( youtubeId ) {
						maybeCreateModal();

						loadYtJs( youtubeId );
						makeSureItFits( $modalContent );
						showModal();
					}
				} );

				$elem.on( 'click touchend', '.video-lightbox', function ( e ) {
					if ( $( e.target ).hasClass( 'video-lightbox' ) || $( e.target ).hasClass( 'video-lightbox__close' ) || $( e.target ).is( 'svg' ) ) {
						closeModal();
					}
				} );
			},

			maybeCreateModal = function () {

				if ( typeof  $modalContent == 'undefined' ) {
					$modal = $( '<div class="video-lightbox">' + closeSvg + '<div class="video-lightbox__safety-max"></div></div>' ).appendTo( 'body' ).hide();
					$modalContent = $( '<div class="video-lightbox__video-content"></div>' ).appendTo( $modal.find( '.video-lightbox__safety-max' ) );
				}

				if ( typeof isModalOpen == 'undefined' ) {
					isModalOpen = false;
				}

				debounceResize();

			},


			showModal = function () {
				if ( !isModalOpen ) {
					$modal.stop().fadeIn( 'fast', function () {
							isModalOpen = true;
						}
					);

				}
			},

			closeModal = function () {
				$modal.stop().fadeOut( 'fast' );
				$modalContent.html( '' );
				isModalOpen = false;
			},

			makeSureItFits = function () {

				var $win = $( window ),
					winHeight = $win.height(),
					winWidth = $win.width(),
					vidRatio = 16 / 9,
					vidWidthCalRatio = 9 / 16,
					safetyRatio = 0.8,
					maxHeight = winWidth / vidRatio * safetyRatio,
					calcWidth = Math.floor( ( winHeight * safetyRatio) * vidRatio ),
					doesItFit = maxHeight < winHeight;


				if ( calcWidth > winWidth ) {
					$modal.find( '.video-lightbox__safety-max' ).outerWidth( Math.floor( winWidth * 0.9 ) );
				} else if ( !doesItFit ) {
					$modal.find( '.video-lightbox__safety-max' ).outerWidth( calcWidth );
				} else {
					$modal.find( '.video-lightbox__safety-max' ).outerWidth( Math.floor( winWidth * safetyRatio ) );
				}


			},
			debounceResize = function () {

				if ( typeof  debouncedModalFit === 'undefined' ) {

					var debounceFitting = debounce( function () {
						makeSureItFits();
					}, 250 );

					window.addEventListener( 'resize', debounceFitting );

					debounceModalFit = true;
				}
			},

			closeSvg = '<div class="video-lightbox__close"><svg version="1.1" class="video-modal-close-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 28.991 29.698" enable-background="new 0 0 28.991 29.698" xml:space="preserve"><g id="XMLID_2_"><line id="XMLID_1_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="0.354" y1="28.638" x2="28.638" y2="0.354"/><line id="XMLID_3_" fill="none" stroke="#333333" stroke-miterlimit="10" x1="28.638" y1="29.345" x2="0.354" y2="1.061"/></g></svg></div>',
			loadYtJs = function ( videoId ) {
				if ( typeof CAF == 'undefined' ) {
					CAF = {};
				}

				if ( typeof CAF.youtubeJsLoaded == 'undefined' || CAF.youtubeJsLoaded != true ) {
					var tag = document.createElement( 'script' );

					tag.src = "//www.youtube.com/iframe_api";
					var firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ];
					firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

					if ( typeof window.onYouTubeIframeAPIReady == 'undefined' ) {
						window.onYouTubeIframeAPIReady = function () {
							CAF.youtubeJsLoaded = true;

							setupAndPlayVideo( videoId );
						}
					}

				} else {
					setupAndPlayVideo( videoId );
				}
			},
			setupAndPlayVideo = function ( videoId ) {

				var idUniqueness = Date.now() / 1000 | 0,
					idToUse = 'yt-frame--' + idUniqueness,
					$currPlayer;


				$currPlayer = $( '<div id="' + idToUse + '" />' ).appendTo( $modalContent );

				if ( typeof CAF.players == 'undefined' ) {
					CAF.players = {};
				}

				// ref: https://developers.google.com/youtube/player_parameters
				CAF.players[ idToUse ] = new YT.Player(
					idToUse, {
						videoId    : videoId,
						playerVars : {
							autohide       : 2,
							autoplay       : 0,
							controls       : 1,
							loop           : 0,
							modestbranding : 1,
							rel            : 0,
							showinfo       : 1,
						},
						events     : {
							'onReady' : playVideo
						}
					} );
			},
			playVideo = function ( event ) {

				// Mute if sound option = mute
				if ( typeof CAF != 'undefined' && typeof CAF.OPTIONS != 'undefined' && typeof CAF.OPTIONS.soundOn != 'undefined' && CAF.OPTIONS.soundOn == false ) {
					event.target.setVolume( 0 );
				}


				event.target.playVideo();

			};

		init();
		return this;
	};

}( $ ));